import { UrlPath } from '../types/Enums';
import { PriceRangeEnum } from '../views/Discover/components/ActiveMarkets/types';

export const makeUrlSafe = (wineName: string) => {
  return wineName
    .toLowerCase() // Convert to lowercase
    .trim() // Trim leading/trailing spaces
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-'); // Replace spaces with hyphens
};

export const getAssetIdFromUrl = (url: string) => {
  const urlParts = url.split('_');
  return urlParts[0];
};

interface ProductType {
  assetId: number;
  wineName: string;
  vintage: number;
  unitCount?: number;
  unitSize?: string;
}

export const getProductUrl = <T>(asset: T) => {
  const { assetId, wineName, vintage, unitCount, unitSize } = asset as unknown as ProductType;

  const unitsSizeStr = unitCount ? `${unitCount}x${unitSize}` : '';
  const safeWineName = makeUrlSafe(wineName);
  const pageSlug = `${assetId}_${safeWineName}_${vintage}_${unitsSizeStr}`;
  return `${UrlPath.PRODUCT_PAGE}/${pageSlug}`;
};

export const getPriceRange = (price: number | null) => {
  if (!price) return null;
  if (price < 500) return PriceRangeEnum.Under500;
  if (price < 1000) return PriceRangeEnum.Under1000;
  if (price >= 1000 && price < 2000) return PriceRangeEnum.Range_1k_2k;
  if (price >= 2000 && price < 5000) return PriceRangeEnum.Range_2k_5k;
  if (price >= 5000 && price < 10000) return PriceRangeEnum.Range_5k_10k;
  if (price >= 10000) return PriceRangeEnum.Range_10k_Plus;
  return null;
};

// const sumFields = <T>(data: T[], sumkeys?: (keyof T)[]) => {
//   if (!sumkeys) return {};
//   const sumData: Record<string, number> = {};
//   sumkeys.forEach((key) => {
//     const totalQty = data.reduce((sum, item) => sum + (item[key] as unknown as number), 0);
//     sumData[key as unknown as string] = totalQty;
//   });
//   return sumData;
// };

// export const groupBy = <T>(array: T[], keys: (keyof T)[], sumkeys?: (keyof T)[]) => {
//   const groupData: Record<string, T[]> = {};
//   array.forEach((item) => {
//     const groupKey = keys.map((key) => item[key]).join('-');
//     if (!groupData?.[groupKey]) {
//       groupData[groupKey] = [];
//     }
//     groupData[groupKey].push(item);
//   });

//   const groupedArray = Object.keys(groupData).map((key) => {
//     const obj = groupData[key];
//     const sumData = sumFields(obj, sumkeys);
//     return {
//       ...groupData[key][0],
//       ...sumData,
//     };
//   });

//   return groupedArray;
// };
